import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import Disclaimer from '../Disclaimer';
import { view11ImageOptions } from './views/view11'

class Sprayhood extends Component {
    constructor(props) {
		super(props);
		this.handleSprayhoodChange = this.handleSprayhoodChange.bind(this);
		this.handleBoomCoverChange = this.handleBoomCoverChange.bind(this);
    }

	handleSprayhoodChange(newValue) {
		let configuration = this.props.configuration;
		configuration.Sprayhood = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

	handleBoomCoverChange(newValue) {
		let configuration = this.props.configuration;
		configuration.BoomCover = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

    render() {
		let imageOptions = view11ImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

					<h1><Trans defaults='Sprayhood & Boom Cover' /></h1>

					<p><Trans defaults='Apart from the options below - sprayhood and boom cover - there are also options for cockpit tent, bimini, cockpit cushions and forestay cover. These options are not included in the configurator. Please, contact your local dealer for more information.' /></p>
					<h2><Trans defaults='Sprayhood' /></h2>
					<MaterialSelector label={this.props.configuration.Sprayhood.label} options={this.props.SprayhoodOptions} value={this.props.configuration.Sprayhood} onChange={this.handleSprayhoodChange} />

					<h2><Trans defaults='Boom Cover' /></h2>

					<MaterialSelector label={this.props.configuration.BoomCover.label} options={this.props.BoomCoverOptions} value={this.props.configuration.BoomCover} onChange={this.handleBoomCoverChange} />
                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Sprayhood);


// WEBPACK FOOTER //
// ./src/X43MK2/Sprayhood.js